var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContent',[_c('b-card',[_c('ResetPasswordForm',{attrs:{"target-url":_vm.targetUrl,"activation-key":_vm.activationKey,"new-user":_vm.newUser}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }